import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { assessmentScore, guidedtourChange, whichActiveView } from '@holmescorp/lcc-state';
import { logQuiz } from '@holmescorp/logger';
import { numeral } from '@holmescorp/numeral';
import { publish } from '@holmescorp/pub-sub';
import css from '../../css/questionfeedback.m.css';
import { QuestionQueue } from '../../support/questionqueue';
import { ScoreRollup } from '../../support/score-rollup';
import { setInreview, setIsaudit } from '../../support/state';
import { QFAuditBase } from './auditbase';
import { Countdown } from '../../support/countdown-timer';
import { CountdownTimer } from '../../widgets/countdown-timer';
const isEmpty = (obj) => Object.keys(obj).length === 0;
let PretestQuestionFeedback = class PretestQuestionFeedback extends QFAuditBase {
    countdown = null;
    onDetach() {
        this.countdown && this.countdown.stop();
        this.countdown = null;
    }
    run_quiz_end() {
        const { info } = this.properties;
        const lastresult = info && info.lastresult;
        const hasLastresult = lastresult && !isEmpty(lastresult);
        const percent = hasLastresult ? lastresult.totalpercentcorrect * 0.01 : 0;
        assessmentScore({ score: `${numeral(percent).format('0%')}` });
        return [];
    }
    buttons() {
        const { quiz = {}, quizstore, info, isrunning, quizid, theme, localizedBundle: { messages: { continue: continueText = 'Continue', start_over: restartText = 'Start Over', begin: beginText = 'Begin', review_last_attempt: reviewText = '', hide_begin_on_quiz_end = 'none' } } } = this.properties;
        const { use_restart } = quiz;
        const { svc } = this;
        const noBeginOnFinal = isrunning === 'final' && hide_begin_on_quiz_end !== 'none';
        if (use_restart) {
            if (this.countdown === null) {
                const { countdowntime } = info;
                this.countdown = new Countdown(countdowntime, quizstore);
            }
            this.countdown && this.countdown.start();
            return [
                v('div', { xqa: 'action continue', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'continue',
                        onClick: () => {
                            logQuiz.info(`continue quiz ${quizid}`);
                            setIsaudit(quizstore)({ isaudit: false });
                            setInreview(quizstore)({ inreview: false });
                            svc.continue_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup();
                            });
                        }
                    }, [continueText])
                ]),
                v('div', { key: `restart-block`, xqa: 'action restart', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'restart',
                        onClick: () => {
                            logQuiz.info(`restart quiz ${quizid}`);
                            this.countdown && this.countdown.stop();
                            this.countdown = null;
                            setIsaudit(quizstore)({ isaudit: false });
                            setInreview(quizstore)({ inreview: false });
                            svc.restart_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup(true);
                            });
                        }
                    }, [restartText])
                ]),
                v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
                    v('div', { classes: [this.theme(css.timer)] }, [w(CountdownTimer, { quizstore, countdown: '' })])
                ])
            ];
        }
        else {
            const lastresult = info && info.lastresult;
            const hasLastresult = lastresult && !isEmpty(lastresult);
            return [
                v('div', { key: `begin-block`, xqa: 'action begin', classes: [this.theme(css.oneaction)] }, [
                    noBeginOnFinal
                        ? null
                        : w(Button, {
                            theme,
                            key: 'begin',
                            onClick: () => {
                                logQuiz.info(`begin quiz ${quizid}`);
                                this.countdown && this.countdown.stop();
                                this.countdown = null;
                                setIsaudit(quizstore)({ isaudit: false });
                                setInreview(quizstore)({ inreview: false });
                                svc.start_quiz().then((v) => {
                                    this.startquiz = v;
                                    this.quiz_startup();
                                });
                            }
                        }, [beginText])
                ]),
                hasLastresult && !quiz.attempts_noaudit
                    ? w(Button, {
                        theme,
                        key: 'audit',
                        onClick: () => {
                            this.audit_init();
                            const { auditsvc } = this;
                            logQuiz.info(`audit quiz ${quizid}`);
                            setIsaudit(quizstore)({ isaudit: true });
                            setInreview(quizstore)({ inreview: false });
                            auditsvc.start_quiz().then(() => {
                                this.startquiz = { cursor: 0, status: 'feedback' };
                                this.audit_startup();
                            });
                        }
                    }, [reviewText])
                    : null
            ];
        }
    }
    render_page() {
        const { isPlaceholder, messages: { study_after_pretest: studyAfterPretest = false } } = this.properties.localizedBundle;
        if (isPlaceholder) {
            return [];
        }
        const { info, isrunning, instancekey = '', quizstore } = this.properties;
        const callback = () => {
            const nextView = studyAfterPretest ? 'study' : 'assess';
            whichActiveView({ whichActive: nextView });
            publish('site/homepage');
        };
        switch (isrunning) {
            case 'quiz': {
                if (this.countdown === null) {
                    const { countdowntime } = info;
                    this.countdown = new Countdown(countdowntime, quizstore);
                }
                this.countdown && this.countdown.start();
                const { startquiz, svc } = this;
                const finalize = () => {
                    if (this.countdown !== null) {
                        this.countdown.stop();
                        this.countdown = null;
                    }
                    this.finalize();
                };
                return [
                    w(QuestionQueue, {
                        key: `${instancekey}-queue`,
                        svc,
                        finalize,
                        startquiz,
                        quizstore
                    })
                ];
            }
            case 'audit':
                return this.run_audit();
            case 'final':
                this.countdown && this.countdown.stop();
                this.countdown = null;
                guidedtourChange({ guidedtour: true });
                this.run_quiz_end();
                callback();
                return [];
            default:
                return this.run_quiz_begin();
        }
    }
    render() {
        const { quiz, info, key, quizstore } = this.properties;
        const hasdata = quiz && info;
        !hasdata && this.load_quiz();
        return v('div', { key, xqa: `progression pretest question-feedback` }, hasdata
            ? [w(ScoreRollup, { key: `rollup-${key}`, quizstore }, this.render_page())]
            : this.render_loading());
    }
};
PretestQuestionFeedback = __decorate([
    theme(css)
], PretestQuestionFeedback);
export { PretestQuestionFeedback };
export default PretestQuestionFeedback;
